import {pageInfo, exportData,getAppointmentDetail,downloadContractTemplate,downloadPurchOrderTemplate,importContractData,importPurchOrderData, cancel} from './../api';
import {contractType, goodsCategory, plant,getAppointmentStatus, getWorkFlowLog, receiveStatus} from '../../../../api'
import {Message} from 'element-ui';

const appointment = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    contractTypeObj: [],
    goodsCategoryObj: [],
    plantObj: [],
    exportObj: [],
    detailObj: [],
    appointmentObj: [],
    appointmentWorkFlowLogObj: [],
    downloadContractTemplateObj: null,
    downloadPurchOrderTemplateObj: null,
    importContractDataObj: null,
    importPurchOrderDataObj: null,
    cancelObj: null,
    receiveStatusObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true, item.cancelFlag == '10' ? true : false]}));
    },
    CONTRACT_TYPE(state, data) {
      state.contractTypeObj = data;
    },
    GOODS_CATEGORY(state, data) {
      state.goodsCategoryObj = data;
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    GET_APPOINTMENT_STATUS(state, data){
      state.appointmentObj = data;
    },
    GET_APPOINTMENT_WORK_FLOW_LOG(state, data){
      state.appointmentWorkFlowLogObj = data;
    },
    GET_APPOINTMENT_DETAIL(state, data){
      state.detailObj = data;
    },
    DOWNLOAD_CONTRACT_TEMPLATE(state, data){
      state.downloadContractTemplateObj = data;
    },
    DOWNLOAD_PURCH_ORDER_TEMPLATE(state, data){
      state.downloadPurchOrderTemplateObj = data;
    },
    IMPORT_CONTRACT_DATA(state, data) {
      state.importContractDataObj = data;
    },
    IMPORT_PURCH_ORDER_DATA(state, data) {
      state.importPurchOrderDataObj = data;
    },
    CANCEL_DATA(state, data){
      state.cancelObj = data;
    },
    RECEIVE_STATUS_DATA(state, data){
      state.receiveStatusObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async contractType({commit}, obj) {
      let resp = await contractType(obj);
      commit('CONTRACT_TYPE', resp);

    },
    async goodsCategory({commit}, obj) {
      let resp = await goodsCategory(obj);
      commit('GOODS_CATEGORY', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async getAppointmentStatus({commit}, obj) {
      let resp = await getAppointmentStatus(obj);
      commit('GET_APPOINTMENT_STATUS', resp);
    },
    async getAppointmentWorkFlowLog({commit}, obj){
      let resp = await getWorkFlowLog(obj);
      commit('GET_APPOINTMENT_WORK_FLOW_LOG', resp);
    },
    async getAppointmentDetail({commit}, obj){
      let resp = await getAppointmentDetail(obj);
      commit('GET_APPOINTMENT_DETAIL', resp);
    },
    //下载合同订单模板
    async downloadContractTemplate({commit}, obj){
      let resp = await downloadContractTemplate(obj);
      commit('DOWNLOAD_CONTRACT_TEMPLATE', resp);
    },
    //下载市场订单模板
    async downloadPurchOrderTemplate({commit}, obj){
      let resp = await downloadPurchOrderTemplate(obj);
      commit('DOWNLOAD_PURCH_ORDER_TEMPLATE', resp);
    },
    //导入合同模板
    async importContractData({commit}, obj){
      let resp = await importContractData(obj);
      commit('IMPORT_CONTRACT_DATA', resp);
    },
    //导入市场订单模板
    async importPurchOrderData({commit}, obj){
      let resp = await importPurchOrderData(obj);
      commit('IMPORT_PURCH_ORDER_DATA', resp);
    },
    //预约单取消
    async cancel({commit}, obj){
      let resp = await cancel(obj);
      commit('CANCEL_DATA', resp);
    },
    //收货状态
    async receiveStatus({commit}, obj){
      let resp = await receiveStatus(obj);
      commit('RECEIVE_STATUS_DATA', resp);
    },
  }
}
export default appointment



// WEBPACK FOOTER //
// ./src/page/bd/appointment/store/appointment.store.js